module.exports = __webpack_public_path__ + "static/media/leftimg.d0052259.png";